module.exports = __webpack_public_path__ + "img/member-illustration-modal.3e026c69.jpeg";